import { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { AuthShell } from "@/components/account/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell>
      {sent ? (
        <div className="mt-10 space-y-4" data-testid="forgot-password-sent">
          <MailCheck className="h-10 w-10 text-primary" />
          <h2 className="text-lg font-serif font-semibold">Check your inbox</h2>
          <p className="text-sm text-muted-foreground">
            If an account exists for <strong>{email}</strong>, a reset link is on its way. It expires in 30 minutes.
            Don't see it? Check your spam folder.
          </p>
          <Link to="/login" className="text-sm text-primary hover:underline inline-block" data-testid="back-to-login-link">← Back to sign in</Link>
        </div>
      ) : (
        <>
          <p className="text-muted-foreground mt-6">
            Enter your email address and we'll send you a link to choose a new password.
          </p>
          <form onSubmit={submit} className="mt-10 space-y-5" data-testid="forgot-password-form">
            <div className="space-y-2">
              <Label htmlFor="fp-email">Email address</Label>
              <Input id="fp-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                     placeholder="you@beckministries.org" className="h-11" data-testid="forgot-password-email-input" />
            </div>
            {error && <p className="text-sm text-destructive" data-testid="forgot-password-error">{error}</p>}
            <Button type="submit" disabled={busy} className="w-full h-11 text-base" data-testid="forgot-password-submit-btn">
              {busy ? "Sending…" : "Email me a reset link"}
            </Button>
          </form>
          <Link to="/login" className="text-sm text-primary hover:underline inline-block mt-6" data-testid="back-to-login-link">← Back to sign in</Link>
        </>
      )}
    </AuthShell>
  );
}
